const isStagingEnvironment = process.env.NODE_ENV === "staging"
const isProductionEnvironment = process.env.NODE_ENV === "production"

export default {
  contentful: {
    spaceId: process.env.CONTENTFUL_SPACE_ID,
    environmentId: process.env.CONTENTFUL_ENVIRONMENT_ID,
    accessToken: process.env.CONTENTFUL_DELIVERY_API_ACCESS_TOKEN
  },
  sentry: {
    dsn: (isStagingEnvironment || isProductionEnvironment) && process.env.SENTRY_DSN
  },
  stripe: {
    apiKey: process.env.STRIPE_API_KEY || "pk_test_5TIuCphlnHVFQDlQlucyIcRL00J3ESEtC3"
  },
  friendbuy: {
    friendbuyKey: process.env.FRIENDBUY_KEY || "ejB-qUM"
  },
  google: { maps: process.env.GOOGLE_MAPS_API_KEY },
  optimize: {
    containerId: process.env.GOOGLE_OPTIMIZE_CONTAINER,
    experiments: {
      bypLtddProducts: process.env.GOOGLE_EXPERIMENT_BYP_LTDD_PRODUCTS_ID
    }
  }
}
